module.exports = __webpack_public_path__ + "media/public/images/about/description/partner1-2fb1f08a960128afd8bff1df70839c52.png";